import { useEffect, useState } from "react";
import { CalendarDays, Clock, Users, Plane, Building2, Package } from "lucide-react";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) { return d ? new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }) : "-"; }

export default function JamaahProgram() {
  const [program, setProgram] = useState(undefined);

  useEffect(() => {
    axios.get(`${API}/jamaah/program`).then(({ data }) => setProgram(data)).catch(() => setProgram(null));
  }, []);

  if (program === undefined) return <LoadingScreen />;

  return (
    <div data-testid="jamaah-program-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Program Saya</h1>
        <p className="text-sm text-[#64748B]">Detail program Haji/Umrah yang Anda ikuti.</p>
      </div>

      {!program ? (
        <EmptyState icon={Package} title="Belum ada program terpilih" description="Silakan pilih program Haji atau Umrah untuk melanjutkan." />
      ) : (
        <div className="overflow-hidden rounded-2xl bg-white shadow-[0_2px_10px_rgba(15,107,79,0.05)]" data-testid="jamaah-program-card">
          <img src={program.cover_image} alt={program.name} className="h-52 w-full object-cover" />
          <div className="p-6">
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-xl font-bold text-[#1F2937]">{program.name}</h2>
              <StatusBadge status={program.status} />
            </div>
            <div className="mt-5 grid grid-cols-1 gap-3 text-sm text-[#1F2937] sm:grid-cols-2">
              <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#0F6B4F]" /> Keberangkatan: {formatDate(program.departure_date)}</p>
              <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#0F6B4F]" /> Durasi: {program.duration_days} Hari</p>
              {program.airline && <p className="flex items-center gap-2"><Plane className="h-4 w-4 text-[#0F6B4F]" /> {program.airline}</p>}
              {program.hotel && <p className="flex items-center gap-2"><Building2 className="h-4 w-4 text-[#0F6B4F]" /> {program.hotel}</p>}
            </div>
            {program.guide_info && (
              <div className="mt-5 flex items-center gap-3 rounded-xl bg-[#F5F9F7] p-4">
                <img src={program.guide_info.photo_url} alt={program.guide_info.name} className="h-12 w-12 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-medium text-[#1F2937]">{program.guide_info.name}</p>
                  <p className="text-xs text-[#64748B]">{program.guide_info.position}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
